module.exports = {"id":"232294","name":"Ryota Morioka","rating":"75","photo":"./data/images/photos/1/232294.png","club":{"name":"RSC Anderlecht","logo":"./data/images/clubs/RSCAnderlecht.png"},"positions":["MOC","ATT"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RyotaMorioka0.json
// module id = 3767
// module chunks = 0